import {copilot} from '@cl/shared';
import {CLStore} from 'common/src/redux/store';
import generalAgent from '../agents/generalAgent';
import createChat from '../store/actions/createChat';

export default function initializeCopilot(store: CLStore) {
  store.dispatch(createChat());
  copilot.registerAgent(generalAgent(store));
}
